import axios, {AxiosResponse} from 'axios'
import {AnnouncementListModel, AnnouncementModel} from '../models/AnnouncementModels'

const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL

export const CONTROLLER_URL = `${AUTH_API_URL}/Announcements`

export const GetAnnouncementList = (): Promise<AnnouncementListModel> => {
  return axios.get(`${CONTROLLER_URL}/GetAnnouncementList`).then((response: AxiosResponse<AnnouncementListModel>) => response.data)
}

export const GetAnnouncementDisplayList = (displayCount:number):Promise<AnnouncementModel[]> =>{
  return axios.get(`${CONTROLLER_URL}/GetAnnouncementDisplayList/${displayCount}`).then((response: AxiosResponse<AnnouncementModel[]>) => response.data)
}